import { IconButton } from "@mui/material"
import { useDialog } from "lib/@hooks/useDialog"
import Iconify from "minimals-template/components/Iconify"
import { TaskOrderChangesDialog } from "./task-order-changes-dialog"
import { MOVEMENTS_AMENDS_KEY } from "authoring/routes/project/amends/lib/constants/amends-keys"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useScheduleEditorCompareTasks } from "./hooks/use-schedule-editor-compare-tasks"
import { getTaskIdentifierForAmendsKey } from "authoring/routes/project/amends/lib/task-amends-key"
import { normalisePlainText } from "authoring/routes/project/amends/lib/normalise-plain-text.mjs"

export function TaskOrderAuthorNoteBoxAction({ amend }) {
    const { target } = useBoundContext()
    const { publishedTasks } = useScheduleEditorCompareTasks()
    const openDialog = useDialog(<TaskOrderChangesDialog />, { maxWidth: "md", fullWidth: true })

    if (!isMovements(amend)) return null

    return (
        <IconButton
            aria-label="View task order changes"
            size="small"
            color="primary"
            sx={{ p: 0.25, mt: 0.25 }}
            onClick={showTaskOrderChanges}
            data-cy="task-order-view-changes"
        >
            <Iconify icon="mdi:eye" width={18} />
        </IconButton>
    )

    async function showTaskOrderChanges() {
        const originalOrder = buildOrderFromTasks(publishedTasks) ?? amend?.payload?.originalOrder ?? []
        const tailoredOrder = buildOrderFromTasks(target?.tasks) ?? amend?.payload?.tailoredOrder ?? []
        await openDialog({ originalOrder, tailoredOrder })
    }
}

function isMovements(amend) {
    const amendsKey = amend?.payload?.amendsKey ?? amend?.payload?.field
    return amendsKey === MOVEMENTS_AMENDS_KEY
}

function buildOrderFromTasks(tasks) {
    if (!tasks) return null
    return tasks
        .filter((task) => !task?.isHeader)
        .map((task, index) => ({
            taskId: getTaskIdentifierForAmendsKey(task),
            title: normalisePlainText(task?.title) || null,
            position: index + 1,
        }))
}
